import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as maplibregl from 'maplibre-gl';
import { BaseEditComponent } from '../../Services/BaseEditComponent';
import { ConfigService } from "../../Services/ConfigService";
import { ZipCodeInfoService } from '../../Services/Custom/ServiceZipCodeInfo';
import { Guid } from 'guid-typescript';
import { CompanyService } from "../../Services/Custom/ServiceCompany";
import { StorageLocationService } from "../../Services/Custom/ServiceStorageLocation";
import { distinctUntilChanged, skip, debounceTime, switchMap } from 'rxjs';

@Component({
	selector: 'DeliveryZoneMap',
	templateUrl: 'DeliveryZoneVisualEdit.html',

})
export class DeliveryZoneVisualEditComponent extends BaseEditComponent implements OnInit, AfterViewInit {

	hoveredStateId = '';

	ngOnInit() {
		this.isSmallScreen = window.innerWidth <= 992;
		this.sizeEmitter.subscribe(width => {
			this.isSmallScreen = width <= 992;
		})

		this.fetchDataSubject
			.pipe(
				debounceTime(250),
				distinctUntilChanged(),
				switchMap((data: TooBig4Car.Logic.MapRequestData) => this.myZipCodeService.loadAllForRectangle(data.lat1, data.lng1, data.lat2, data.lng2, data.groupID, data.customerID)),
			)
			.subscribe(results => {
				this.displayResults(results, false);
				this.isSaving = false;
			});
	}
	sizeEmitter = new EventEmitter<number>();
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.sizeEmitter.next(window.innerWidth);
	}


	isSmallScreen = false;

	ngAfterViewInit(): void {
		this.createMap();
	}

	_highlightGroupID: string = null;
	highlightZoneGroup(groupID: string, zoneDescription: string) {
		if (this._highlightGroupID != groupID) {
			if (this.mapper) {
				this._highlightGroupID = groupID;

			var zipSource: maplibregl.GeoJSONSource = this.mapper.getSource('zipSource');
				if (zipSource) {
					const features = this.mapper.querySourceFeatures('zipSource', {
						sourceLayer: 'group-selected',
					});
					var boundsChanged = false;
					var updatebounds = this.mapper.getBounds();
					const changes: maplibregl.GeoJSONFeatureDiff[] = [];
					features.forEach((a: any) => {
						var needsChange = false;
						if (!this.configData.IsEmptyGuid(this._highlightGroupID)) {
							if (a.properties.GroupID == this._highlightGroupID) {
								if (!a.properties.isGroupSelected) {
									a.properties.isGroupSelected = true;
									needsChange = true;
								}
							} else if ((zoneDescription ?? '').indexOf(a.properties.zip) >= 0) {
								if (!a.properties.isGroupSelected) {
									a.properties.isGroupSelected = true;
									needsChange = true;
								}
							} else {
								if (a.properties.isGroupSelected) {
									a.properties.isGroupSelected = false;
									needsChange = true;
								}
							}
						} else {
							if (a.properties.isGroupSelected) {
								a.properties.isGroupSelected = false;
								needsChange = true;
							}
						}
						if (needsChange) {
							a.geometry.coordinates[0].forEach((coord: any) => {
								updatebounds.extend(coord);
								boundsChanged = true;
							});
							changes.push({
								id: a.id.toString(),
								addOrUpdateProperties: [
									{
										key: 'isGroupSelected',
										value: a.properties.isGroupSelected
									},
									{
										key: 'isSingleSelected',
										value: false
									},
								]
							});
						}
					});

					zipSource.updateData({ update: changes });
					if (boundsChanged) {
						if (!updatebounds.isEmpty()) {
							this.mapper.fitBounds(updatebounds, {
								padding: { top: 10, bottom: 25, left: 15, right: 5 }
							});
						}
					}
				}
			}
		}
	}

	_highlightSingleZip: string = null;
	highlightSingleZip(zip: string) {
		if (this._highlightSingleZip != zip) {
			this._highlightSingleZip = zip;

			var zipSource: maplibregl.GeoJSONSource = this.mapper.getSource('zipSource');
			if (zipSource) {
				const features = this.mapper.querySourceFeatures('zipSource', {
					sourceLayer: 'single-selected',
				});
				var boundsChanged = false;
				var updatebounds = this.mapper.getBounds();
				const changes: maplibregl.GeoJSONFeatureDiff[] = [];
				features.forEach((a: any) => {
					var needsChange = false;
					if (!this.configData.IsEmptyGuid(this._highlightSingleZip)) {
						if (a.properties.zip == this._highlightSingleZip) {
							if (!a.properties.isSingleSelected) {
								a.properties.isSingleSelected = true;
								needsChange = true;
							}
						} else {
							if (a.properties.isSingleSelected) {
								a.properties.isSingleSelected = false;
								needsChange = true;
							}
						}
					} else {
						if (a.properties.isSingleSelected) {
							a.properties.isSingleSelected = false;
							needsChange = true;
						}
					}
					if (needsChange) {
						a.geometry.coordinates[0].forEach((coord: any) => {
							updatebounds.extend(coord);
							boundsChanged = true;
						});
						changes.push({
							id: a.id.toString(),
							addOrUpdateProperties: [
								{
									key: 'isSingleSelected',
									value: a.properties.isSingleSelected
								},
								{
									key: 'isGroupSelected',
									value: false
								}
							]
						});
					}
				});

				zipSource.updateData({ update: changes });
				if (boundsChanged) {
					if (!updatebounds.isEmpty()) {
						this.mapper.fitBounds(updatebounds, {
							padding: { top: 10, bottom: 25, left: 15, right: 5 }
						});
					}
				}
			}
		}
	}

	isProgrammaticMove = false;
	createMap() {

		var thisHolder = this;
		if (thisHolder.showMap) {
			if (null == this.mapper) {


				this.myCompanyService.get(this.configData.companyID)
					.subscribe((comp: TooBig4Car.Logic.Company) => {

						this.mapper = new maplibregl.Map({
							container: this.mapContainer.nativeElement,
							style: 'https://tiles.openfreemap.org/styles/bright',
							center: [comp.Address.Longitude, comp.Address.Latitude],
							zoom: 10
						});

						this.mapper.addControl(new maplibregl.NavigationControl(), 'top-right');

						// When the user moves their mouse over the state-fill layer, we'll update the
						// feature state for the feature under the mouse.
						this.mapper.on('mousemove', 'zip-selected', (e) => {
							if (e.features.length > 0) {
								if (this.hoveredStateId != e.features[0].properties.zip) {
									if (this.hoveredStateId) {
										this.mapper.setFeatureState(
											{ source: 'zipSource', id: this.hoveredStateId },
											{ hover: false }
										);
									}
									this.hoveredStateId = e.features[0].properties.zip;
									this.mapper.setFeatureState(
										{ source: 'zipSource', id: this.hoveredStateId },
										{ hover: true }
									);


									// Change the cursor style as a UI indicator.
									this.mapper.getCanvas().style.cursor = 'pointer';

									//const coordinates = features[0].geometry.coordinates.slice();
									var description = e.features[0].properties.zip;
									if (e.features[0].properties.CityState) {
										description += '<br />' + e.features[0].properties.CityState;
									}
									description += '<br />Base: $' + e.features[0].properties.BaseRate;
									if ("string" == typeof (e.features[0].properties.Days)) {
										e.features[0].properties.Days = JSON.parse(e.features[0].properties.Days);
									}
									if (e.features[0].properties.GroupName) {
										description += '<br />Group: ' + e.features[0].properties.GroupName;
									}
									if (e.features[0].properties.ScheduleData) {
										description += '<br /><span class="ws">';
										description += 'Schedule Data: ' + e.features[0].properties.ScheduleData;
										description += '</div>';
									}
									if (e.features[0].properties.OffScheduleData) {
										description += '<br /><span class="ws">';
										description += 'Off Schedule Data: ' + e.features[0].properties.OffScheduleData;
										description += '</div>';
									}
									//// Ensure that if the map is zoomed out such that multiple
									//// copies of the feature are visible, the popup appears
									//// over the copy being pointed to.
									//while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
									//	coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
									//}


									// Populate the popup and set its coordinates
									// based on the feature found.
									popup.setLngLat(e.lngLat).setHTML(description).addTo(this.mapper);
								}
							}
						});

						// When the mouse leaves the state-fill layer, update the feature state of the
						// previously hovered feature.
						this.mapper.on('mouseleave', 'zip-selected', () => {
							if (this.hoveredStateId) {
								this.mapper.setFeatureState(
									{ source: 'zipSource', id: this.hoveredStateId },
									{ hover: false }
								);
							}
							this.hoveredStateId = null;

							this.mapper.getCanvas().style.cursor = '';
							popup.remove();
						});

						if (this._interactive) {
							this.mapper.on('click', 'zip-selected', this.clickEvent);
						}

						// Create a popup, but don't add it to the map yet.
						const popup = new maplibregl.Popup({
							closeButton: false,
							closeOnClick: false
						});

						this.mapper.on('moveend', () => {
							if(thisHolder.isProgrammaticMove) {
								thisHolder.isProgrammaticMove = false;
								return;
							}  
							thisHolder.fetchDataFromMap(false);
						});

						this.myStorageLocationService.loadAll(true)
							.subscribe(locations => this.addWarehouseFlags(locations));
					});
			}
		}
	}

	addWarehouseFlags(locations: TooBig4Car.Logic.StorageLocation[]) {
		const flagPopup = new maplibregl.Popup({
			closeButton: false,
			closeOnClick: false,
			offset: 30
		});

		const flags = new Map<string, { point: { lat: number, lng: number }, locations: TooBig4Car.Logic.StorageLocation[] }>();
		locations.forEach(location => {
			const point = this.addressToLatLng(location.Address);
			if (point) {
				const key = point.lat + ',' + point.lng;
				if (!flags.has(key)) {
					flags.set(key, { point: point, locations: [] });
				}
				flags.get(key).locations.push(location);
			}
		});

		flags.forEach(flag => {
			const content = document.createElement('div');
			flag.locations.forEach((location, index) => {
				const name = document.createElement('div');
				name.className = index > 0 ? 'fw-bold mt-1' : 'fw-bold';
				name.textContent = location.LocationName;
				const address = document.createElement('div');
				address.textContent = location.Address.AsSingleLine;
				content.append(name, address);
			});

			const element = document.createElement('i');
			element.className = 'fa-solid fa-flag warehouse-flag';
			element.style.color = 'red';
			element.style.fontSize = '24px';
			element.style.textShadow = '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff';
			element.addEventListener('mouseenter', () => flagPopup.setLngLat(flag.point).setDOMContent(content).addTo(this.mapper));
			element.addEventListener('mouseleave', () => flagPopup.remove());
			// Keep the zip code layer from reacting to the flag: no zip tooltip, no zip toggle on click.
			element.addEventListener('mousemove', e => e.stopPropagation());
			element.addEventListener('click', e => e.stopPropagation());

			new maplibregl.Marker({ element: element, anchor: 'bottom-left' })
				.setLngLat(flag.point)
				.addTo(this.mapper);
		});
	}

	constructor(
		public configData: ConfigService,
		private myZipCodeService: ZipCodeInfoService,
		private myCompanyService: CompanyService,
		private myStorageLocationService: StorageLocationService,
	) {
		super();
	}

	preface: string = Guid.create().toString();

	clickEvent = (e: any) => {
		var zipSource: maplibregl.GeoJSONSource = this.mapper.getSource('zipSource');
		if (zipSource) {
			const changes: maplibregl.GeoJSONFeatureDiff[] = [];
			const features = e.features;
			features.forEach((feat: any) => {
				if (feat.properties.isSelected) {
					var removed = this.zones.filter(zone => {
						return zone.ZoneName == feat.properties.zip;
					});
					this.zones = this.zones.filter(zone => {
						return zone.ZoneName != feat.properties.zip;
					});
					if (removed.length > 0) {
						this.zoneRemoved.emit(removed);
					}
				} else {
					var dz = {
						ZoneName: feat.properties.zip,
						Description: feat.properties.City,
						State: feat.properties.State,
						DateCreatedUTC: new Date() //Add this to defeat the default trackBy stuff
					} as TooBig4Car.Logic.DeliveryZone;
					this.zones.unshift(dz);
					this.newDeliveryZone.emit(dz);
				}
				changes.push({
					id: feat.id.toString(),
					addOrUpdateProperties: [
						{
							key: 'isSelected',
							value: !feat.properties.isSelected
						}
					]
				})
			});
			zipSource.updateData({ update: changes });
		}
	}

	_showMap = false;

	@Input()
	get showMap(): boolean {
		return this._showMap;
	}

	set showMap(val: boolean) {
		this._showMap = val;
		this.createMap();
	}

	_interactive: boolean = false;

	@Output()
	zoneRemoved = new EventEmitter<TooBig4Car.Logic.DeliveryZone[]>();

	@Output()
	newDeliveryZone = new EventEmitter<TooBig4Car.Logic.DeliveryZone>();

	@Input()
	set Interactive(val: boolean) {
		if (this._interactive != val) {
			this._interactive = val;

			if (this.mapper) {
				if (!this._interactive) {
					this.mapper.off('click', 'zip-selected', this.clickEvent);
				} else {
					this.mapper.on('click', 'zip-selected', this.clickEvent);
				}
			}
		}
	}


	mapper: maplibregl.Map;

	@ViewChild('zipMap')
	private mapContainer!: ElementRef<HTMLElement>;

	@Input()
	showDays: boolean = false;


	_zones: TooBig4Car.Logic.DeliveryZone[] = [];
	@Input()
	set zones(col: TooBig4Car.Logic.DeliveryZone[]) {
		this._zones = col;
	}

	get zones(): TooBig4Car.Logic.DeliveryZone[] {
		return this._zones ?? [];
	}

	_customerID: string = '';

	@Input()
	set customerID(val: string) {
		if (this._customerID != val) {
			this._customerID = val;
			this.fetchData();
		}
	}

	get customerID(): string {
		return this._customerID ?? '';
	}
	_groupID: string = null;

	@Input()
	set groupID(id: string) {
		if (this._groupID != id) {
			this._groupID = id;
			this.fetchData();
		}
	}
	get groupID(): string {
		return this._groupID ?? '';
	}

	Sunday: boolean = true;
	Monday: boolean = true;
	Tuesday: boolean = true;
	Wednesday: boolean = true;
	Thursday: boolean = true;
	Friday: boolean = true;
	Saturday: boolean = true;
	None: boolean = true;

	changeFilter() {
		if (this.mapper) {
			var selectedDays = [];
			if (this.Sunday) {
				selectedDays.push('Sunday');
			}
			if (this.Monday) {
				selectedDays.push('Monday');
			}
			if (this.Tuesday) {
				selectedDays.push('Tuesday');
			}
			if (this.Wednesday) {
				selectedDays.push('Wednesday');
			}
			if (this.Thursday) {
				selectedDays.push('Thursday');
			}
			if (this.Friday) {
				selectedDays.push('Friday');
			}
			if (this.Saturday) {
				selectedDays.push('Saturday');
			}
			if (this.None) {
				selectedDays.push('None');
			}
			if (selectedDays.length > 0 && selectedDays.length < 8) {
				const filterByDays = (days: string[]) => {
					if ((days || []).length === 0) return null;


					var filterCol: ["any", ...any[]] = ['any'];
					//single expression for each org ID
					days.forEach(a => {

						filterCol.push(['in', a, ['get', 'Days']]);
					})

					//merge all expressions
					return filterCol;

				}

				this.mapper.setFilter("zip-selected", filterByDays(selectedDays));



			} else {
				this.mapper.setFilter('zip-selected', null);
			}
		}
	}

	fetchDataSubject = new EventEmitter<TooBig4Car.Logic.MapRequestData>();
	//get the zip geoJSON data from the server
	fetchDataFromMap(force: boolean) {
		//don't load data with an outstanding request
		if (!force && this.isSaving) {
			return;
		}
		this.isSaving = true;

		var mapBounds = this.mapper.getBounds();

		this.fetchDataSubject.next({
			lat1: mapBounds.getNorthEast().lat,
			lng1: mapBounds.getNorthEast().lng,
			lat2: mapBounds.getSouthWest().lat,
			lng2: mapBounds.getSouthWest().lng,
			groupID: this.groupID,
			customerID: this.customerID
		});
		
	}

	fetchData() {
		//don't load data with an outstanding request
		if (this.isSaving) {
			return;
		}
		if (this.mapper) {
			this.isSaving = true;
			if (!this.configData.IsEmptyGuid(this.groupID)) {

				if (!this.configData.IsEmptyGuid(this.customerID)) {
					this.myZipCodeService.loadAllForCustomerDeliveryZoneGroup(this.customerID, this.groupID).subscribe(results => {
						this.displayResults(results, true);
						this.isSaving = false;
						this.fetchDataFromMap(true);
					});
				} else {
					this.myZipCodeService.loadAllForDeliveryZoneGroup(this.groupID).subscribe(results => {
						this.displayResults(results, true);
						this.isSaving = false;
						this.fetchDataFromMap(true);
					});
				}
			} else {
				this.myZipCodeService.loadAll().subscribe(results => {
					this.displayResults(results, true);
					this.isSaving = false;
					this.fetchDataFromMap(true);
				});
			}
		} else {
			var thisholder = this;
			setTimeout(() => {
				thisholder.fetchData();
			}, 1000);
		}
	}

	updateSelectionsForMap() {
		if (this.mapper) {
			var zipSource: maplibregl.GeoJSONSource = this.mapper.getSource('zipSource');
			if (zipSource) {
				const features = this.mapper.querySourceFeatures('zipSource', {
					sourceLayer: 'zip-selected',
				});

				const changes: maplibregl.GeoJSONFeatureDiff[] = [];
				features.forEach((a: any) => {
					var selectCol = this.zones.filter(zone => {
						return zone.ZoneName == a.properties.zip;
					});
					var needsSelectChange = false;
					var needsGroupChange = false;

					if (selectCol.length > 0) {
						if (!a.properties.isSelected) {
							a.properties.isSelected = true;
							needsSelectChange = true;
						}
					} else {
						if (a.properties.isSelected) {
							a.properties.isSelected = false;
							needsSelectChange = true;
						}
					}

					if (!this.configData.IsEmptyGuid(this._highlightGroupID)) {
						if (a.properties.GroupID == this._highlightGroupID) {
							if (!a.properties.isGroupSelected) {
								a.properties.isGroupSelected = true;
								needsGroupChange = true;
							}
						} else {
							if (a.properties.isGroupSelected) {
								a.properties.isGroupSelected = false;
								needsGroupChange = true;
							}
						}
					} else {
						if (a.properties.isGroupSelected) {
							a.properties.isGroupSelected = false;
							needsGroupChange = true;
						}
					}
					if (needsGroupChange) {
						changes.push({
							id: a.id.toString(),
							addOrUpdateProperties: [
								{
									key: 'isGroupSelected',
									value: a.properties.isGroupSelected
								}
							]
						})
					}
					if (needsSelectChange) {
						changes.push({
							id: a.id.toString(),
							addOrUpdateProperties: [
								{
									key: 'isSelected',
									value: a.properties.isSelected
								}
							]
						});
					}
				});

				zipSource.updateData({ update: changes });
			}
		}
	}
	//update the map once we have geoJSON data
	displayResults(results: any, updateMapZoom: boolean) {
		if (results.data.features.length) {
			

			const updatebounds = new maplibregl.LngLatBounds();
			if (this.zones && this.zones.length) {
				results.data.features.forEach((a: any) => {
					var selectCol = this.zones.filter(zone => {
						return zone.ZoneName == a.properties.zip;
					});
					if (selectCol.length > 0) {
						a.properties.isSelected = true;
						a.geometry.coordinates[0][0].forEach((coord: any) => {
							updatebounds.extend(coord);
						});
					}
				});
			}
			results.data.features.forEach((a: any) => {
				if (!this.configData.IsEmptyGuid(this._highlightGroupID)) {
					if (a.properties.GroupID == this._highlightGroupID) {
						if (!a.properties.isGroupSelected) {
							a.properties.isGroupSelected = true;
							a.geometry.coordinates[0][0].forEach((coord: any) => {
								updatebounds.extend(coord);
							});
						}
					}
				}
				if (!this.configData.IsEmptyGuid(this._highlightSingleZip)) {
					if (a.properties.zip == this._highlightSingleZip) {
						if (!a.properties.isSingleSelected) {
							a.properties.isSingleSelected = true;
							a.properties.isGroupSelected = false;
							a.geometry.coordinates[0][0].forEach((coord: any) => {
								updatebounds.extend(coord);
							});
						}
					}
				}
			});
			var zipSource: maplibregl.GeoJSONSource = this.mapper.getSource('zipSource');
			if (zipSource) {
				const oldfeatures = this.mapper.querySourceFeatures('zipSource');
				var toAdd: any[] = [];
				results.data.features.forEach((newFeat: any) => {
					var existing = oldfeatures.filter((oldFeat: any) => oldFeat.properties.zip == newFeat.properties.zip || oldFeat.id == newFeat.properties.zip);
					if (existing.length == 0) {
						toAdd.push(newFeat);
					}
				});
				if (toAdd.length > 0) {
					zipSource.updateData({ add: toAdd });
					oldfeatures.forEach((oldFeat: any) => {
						if (oldFeat.properties.isGroupSelected || oldFeat.properties.isSingleSelected) {
							oldFeat.geometry.coordinates[0].forEach((coord: any) => {
								updatebounds.extend(coord);
							});
						}
					});
					this.isProgrammaticMove = true;
					if (updateMapZoom) {
						if (!updatebounds.isEmpty()) {
							this.mapper.fitBounds(updatebounds, {
								padding: { top: 10, bottom: 25, left: 15, right: 5 }
							});
						}
					}
				}
			} else {
				this.mapper.addSource('zipSource', results);

				this.mapper.addLayer({
					'id': 'single-selected',
					'type': 'fill',
					'source': 'zipSource',
					'layout': {},
					'paint': {
						'fill-color': '#FFFF00',
						'fill-opacity': [
							'case',
							['boolean', ['get', 'isSingleSelected'], false],
							1,
							0
						]
					}
				});

				this.mapper.addLayer({
					'id': 'group-selected',
					'type': 'fill',
					'source': 'zipSource',
					'layout': {},
					'paint': {
						'fill-color': '#FFFF00',
						'fill-opacity': [
							'case',
							['boolean', ['get', 'isGroupSelected'], false],
							1,
							0
						]
					}
				});

				this.mapper.addLayer({
					'id': 'zip-selected',
					'type': 'fill',
					'source': 'zipSource',
					'layout': {},
					'paint': {
						'fill-color': getComputedStyle(document.documentElement).getPropertyValue('--tb-system-color').trim() || '#EB2227',
						'fill-opacity': [
							'case',
							['all',
								['boolean', ['get', 'isSelected']],
								['!', ['get', 'isGroupSelected']],
								['!', ['get', 'isSingleSelected']]
							],
							.5,
							0
						]
					}
				});

				this.mapper.addLayer({
					id: 'zip-borders',
					type: 'line',
					source: 'zipSource',
					paint: {
						'line-color': '#000000',
						'line-width': 1,
					}
				});

				const bounds = new maplibregl.LngLatBounds();
				results.data.features.forEach((feature: any) => {
					feature.geometry.coordinates[0][0].forEach((coord: any) => {
						bounds.extend(coord);
					});
				});

				this.isProgrammaticMove = true;
				this.mapper.fitBounds(bounds, {
					padding: { top: 10, bottom: 25, left: 15, right: 5 }
				});
			}
		}
	}
}
